<template>
  <section>
    <LoadingSpinner v-if="loading" />
    <div v-else class="mx-2">
      <div class="col-md-12 w-100 my-2 card p-2">
        <div class="mx-0 px-0 table-responsive">
          <!-- Table (list clients) + -->
          <Table
            v-if="!loading && !showEmptyImage"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="clients"
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="captainkey"
            @goToAgency="goToAgency"
          >
          </Table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
  },

  data() {
    return {
      filters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      clients: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "task_open_hours",
            type: "time",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
            badges: [
              {
                badge_if: "client_status_id",
                badge_value: "3",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "4",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.appointments.active"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "5",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.appointments.standby"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "7",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.payment.Canceled"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "8",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.label.pendingdeleted"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "9",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.label.validating"),
              },
            ],
          },
        ],
        [
          {
            value: "olv_sales_name",
          },
        ],
      ],
      headers: [
        {
          label: "Time",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.label.client"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.label.sales"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },

      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },

  mounted() {
    this.loadOrders();
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    loadOrders(order, filter = []) {
      targetsService.getClientAttribution("26").then((response) => {
        console.log(response);
        if (response !== undefined) {
          this.clients = response.filter(client => client.client_id !== "3186");
          this.loading = false;
        }
      });
    },
    editOrder(index) {
      this.$router.push("/clients/" + index);
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },

    goToAgency(client_id, client_name) {
      //(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);
      if (
        !this.hasPermissions("isAgencyManager") ||
        this.hasPermissions("adminAgency")
      ) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
